import React from "react";

export default function Banner2() {
  return (
    <section className="banner big" aria-labelledby="banner2-heading">
      <div className="banner__bg">
        <img src="/images/banner/2.png" alt="Proxium's hair care treatment technology banner" />
      </div>
      <div className="auto__container">
        <div className="banner__inner">
          <div className="banner__inner-title">
            <h2 id="banner2-heading">
              "Proxium's Commitment to Advanced, <br /> Targeted Hair Care Treatments"
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
}
